
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.667 5.6v20.8h26.666V5.6H2.667zM1.333 3C.597 3 0 3.582 0 4.3v23.4c0 .718.597 1.3 1.333 1.3h29.334c.736 0 1.333-.582 1.333-1.3V4.3c0-.718-.597-1.3-1.333-1.3H1.333z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.078 19.646L0 6.016 1.844 4 16 16.795 30.156 4 32 6.017 16.922 19.646a1.377 1.377 0 01-1.844 0z","fill":"currentColor"}})])
          )
        }
      }
    